module.exports = __webpack_public_path__ + "img/vegetable-kale-350x184.1f8c4674.jpg";